export const spinner = {
  dots:  ['⠋','⠙','⠹','⠸','⠼','⠴','⠦','⠧','⠇','⠏'],
  pulse: ['●','◐','○','◑'],
} as const;

export const fade = { toast: 3000, save: 150 } as const;
